import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(public _authService: AuthService) {}

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {

        const token = this._authService.getToken();

        if (token) {
            req = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              });

        }else {
            req = req.clone({
                setHeaders: {
                  Authorization: `api_key ${environment.backendApiKey}`
                }
              });
        }

        return next.handle(req);
    }
}
